import {
  GetConfigSubgradesResponse,
  UpdateSubgradesConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsSubgradesService = {
  async list(): Promise<GetConfigSubgradesResponse> {
    const response = await httpClient.get<GetConfigSubgradesResponse>(
      "v1/config/internal-grade/subgrades",
    );
    return response;
  },
  async update(body: UpdateSubgradesConfig): Promise<void> {
    await httpClient.patch("v1/config/internal-grade/subgrades", body);
  },
};

export default ConfigurationsSubgradesService;
